import { SdObjType } from '@work4all/models/lib/Enums/SdObjType.enum';

import { queryIn, queryOr } from '@work4all/utils';

interface BusinessPartner {
  id: string | number;
  data?: {
    id: string | number;
    __typename?: string;
  };
  __typename?: string;
  businessPartnerType?: SdObjType;
}

// Splits business partners by type and creates a filter that includes the type information
// to prevent mixing suppliers and customers with the same IDs
export const splitBusinessPartnersByType = (
  businessPartners: BusinessPartner[],
  field = 'businessPartner.id',
  typeField?: string
) => {
  if (!businessPartners?.length) {
    return null;
  }

  const customers: string[] = [];
  const suppliers: string[] = [];

  businessPartners.forEach((bp) => {
    const id = bp.id || bp.data?.id;
    if (!id) return;

    let type: SdObjType;

    if (bp.businessPartnerType) {
      type = bp.businessPartnerType;
    } else if (bp.__typename === 'Kunde' || bp.data?.__typename === 'Kunde') {
      type = SdObjType.KUNDE;
    } else {
      type = SdObjType.LIEFERANT;
    }

    if (type === SdObjType.KUNDE) {
      customers.push(String(id));
    } else if (type === SdObjType.LIEFERANT) {
      suppliers.push(String(id));
    }
  });

  const conditions = [];

  // If no typeField is provided, we can't filter by type
  if (!typeField) {
    const allIds = [...customers, ...suppliers];
    if (allIds.length > 0) {
      return { [field]: queryIn(allIds) };
    }
    return null;
  }

  if (customers.length > 0) {
    conditions.push({
      $and: [
        { [field]: queryIn(customers) },
        { [typeField]: { $eq: SdObjType.KUNDE } },
      ],
    });
  }

  if (suppliers.length > 0) {
    conditions.push({
      $and: [
        { [field]: queryIn(suppliers) },
        { [typeField]: { $eq: SdObjType.LIEFERANT } },
      ],
    });
  }

  // If both types are present, use $or to combine them
  if (conditions.length > 1) {
    return queryOr(conditions);
  } else if (conditions.length === 1) {
    return conditions[0];
  }

  return null;
};
